var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgValidatedCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25 24",
    style: {
      enableBackground: "new 0 0 25 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F59E0B;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.2,7.8v3.5c0,1.5,0.4,2.9,1.3,4.1c0.8,1.2,1.9,2,3.2,2.4c1.3-0.4,2.3-1.2,3.2-2.4c0.8-1.2,1.3-2.6,1.3-4.1 V7.8l-4.4-1.6L8.2,7.8z M15.6,10.4l-3.7,3.7L9.8,12l0.5-0.5l1.6,1.6L15,9.9L15.6,10.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.4,8.3c-0.5-1.2-1.2-2.2-2-3c-0.8-0.8-1.9-1.5-3-2c-1.2-0.5-2.4-0.8-3.7-0.8S10.1,2.8,9,3.2 c-1.2,0.5-2.2,1.2-3,2c-0.9,0.9-1.5,1.9-2,3C3.4,9.4,3.2,10.7,3.2,12s0.2,2.6,0.8,3.7c0.5,1.2,1.2,2.2,2,3c0.8,0.9,1.9,1.5,3,2 c1.2,0.5,2.4,0.8,3.7,0.8s2.6-0.2,3.7-0.8c1.2-0.5,2.2-1.2,3-2c0.9-0.8,1.5-1.9,2-3c0.5-1.2,0.8-2.4,0.8-3.7S21.9,9.4,21.4,8.3z  M17.9,11.3c0,1.7-0.5,3.2-1.5,4.6c-1,1.4-2.2,2.3-3.7,2.7c-1.5-0.4-2.7-1.3-3.7-2.7c-1-1.4-1.5-2.9-1.5-4.6v-4l5.2-1.9l5.2,1.9 V11.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidatedCircleIcon);
export default __webpack_public_path__ + "static/media/validated-circle-icon.6cc88216f1132e175f7e539c72de981a.svg";
export { ForwardRef as ReactComponent };